import React, { FC, useEffect, useState } from 'react'

import Loader from 'uiKit/loaders/loader'
import { DatasetInfo } from './DatasetInfo'
import { DatasetTables } from './DatasetTables'
import { useDatasets } from '../hooks/useDatasets'
import { DatasetTabs } from './DatasetTabs'
import { alertError, alertSuccess } from 'api'
import { updateDataset } from 'tabs/data/api/datasets'
import { DatasetRelationships } from './DatasetRelationships'

export const DescriptionDatasets: FC = () => {
  const { data, refetch, loading, error } = useDatasets()
  const [selectedDatasetIndex, setSelectedDatasetIndex] = useState<number>(null)
  const [selectedDatasetSubtabIndex, setSelectedDatasetSubtabIndex] = useState<number>(0)

  useEffect(() => {
    if (!selectedDatasetIndex && data?.length && data[0]) {
      setSelectedDatasetIndex(0)
    }
  }, [data])

  if (selectedDatasetIndex > -1 && loading) {
    return <Loader />
  }

  const selectedDataset = data[selectedDatasetIndex]

  const title = selectedDataset?.datasetName
  const text = selectedDataset?.activeVersionDescription?.datasetDescription
  const updatedAt = selectedDataset?.activeVersionDescription?.updatedAt

  const tabs = (data || [])?.map(item => ({
    label: item?.datasetName,
    value: item?.activeVersionDescription?.datasetId,
  }))

  const subtabs = [
    { label: 'Tables', value: 'Tables' },
    { label: 'Relationships', value: 'Relationships' },
  ]
  const subtitle = subtabs[selectedDatasetSubtabIndex].label

  const selectedDatasetId = selectedDataset?.activeVersionDescription?.datasetId

  const handleUpdateDataset = async (datasetDescription: string): Promise<void> => {
    const { datasetId, datasetVersion } = selectedDataset.activeVersionDescription

    try {
      const params = {
        datasetId,
        updateDatasetRequest: {
          datasetDescription,
          datasetVersion: datasetVersion,
        },
      }

      data[selectedDatasetId] = await updateDataset(params)

      alertSuccess('Dataset updated', 3000)
      refetch()
    } catch (error) {
      alertError(error?.message || error || 'Error updating Dataset')
    }
  }

  if (error && !data?.length) {
    return null
  }

  return (
    <div>
      <DatasetTabs
        tabs={tabs}
        activeTab={title}
        style={{
          marginBottom: 36,
          marginTop: '-3rem',
        }}
        onChange={setSelectedDatasetIndex}
      />

      <DatasetInfo
        datasetId={selectedDatasetId}
        title={title}
        text={text}
        updatedAt={updatedAt}
        onChange={handleUpdateDataset}
      />

      <DatasetTabs
        tabs={subtabs}
        activeTab={subtitle}
        style={{ display: 'inline-block', marginTop: '1rem' }}
        onChange={setSelectedDatasetSubtabIndex}
      />

      {selectedDatasetSubtabIndex === 0 && <DatasetTables datasetId={selectedDatasetId} />}
      {selectedDatasetSubtabIndex === 1 && <DatasetRelationships datasetId={selectedDatasetId} />}
    </div>
  )
}
